import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend,
} from "recharts";

const CHART_MARGIN = { top: 10, right: 10, left: -20, bottom: 40 };
const AXIS_TICK = { fontSize: 11, fill: "hsl(var(--muted-foreground))" };
const X_TICK = { fontSize: 10, fill: "hsl(var(--muted-foreground))" };
const TOOLTIP_STYLE = { background: "hsl(var(--popover))", border: "1px solid hsl(var(--border))", borderRadius: 8, fontSize: 12 };
const LEGEND_STYLE = { fontSize: 11 };

export default function ThroughputChart({ data = [] }) {
  if (!data.length) {
    return (
      <div className="rounded-lg border border-dashed border-border p-8 text-center text-sm text-muted-foreground">
        No stage data yet — create jobs to see throughput.
      </div>
    );
  }
  const short = data.map((d) => ({ ...d, label: d.stage.replace(" (Goods Receipt)", "").slice(0, 14) }));
  return (
    <div className="rounded-lg border border-border bg-card p-4" data-testid="throughput-chart" style={{ height: 320 }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={short} margin={CHART_MARGIN}>
          <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" vertical={false} />
          <XAxis dataKey="label" angle={-35} textAnchor="end" interval={0} tick={X_TICK} height={60} />
          <YAxis allowDecimals={false} tick={AXIS_TICK} />
          <Tooltip contentStyle={TOOLTIP_STYLE} labelFormatter={(_, p) => p?.[0]?.payload?.stage || ""} />
          <Legend wrapperStyle={LEGEND_STYLE} />
          <Bar dataKey="completed" stackId="a" fill="#10B981" name="Completed" />
          <Bar dataKey="in_progress" stackId="a" fill="#F59E0B" name="In Progress" />
          <Bar dataKey="not_started" stackId="a" fill="#475569" name="Not Started" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
